__turbopack_context__.v({
  "dialogFooter": "DialogFooter-module__BlU_Tq__dialogFooter",
});
